import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import {Link} from "react-router-dom";



export default function Arrival_new() {
  const [data, setData] = useState([]);
  const headRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    if (!data.length) return;
  
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );
  
    if (headRef.current) observer.observe(headRef.current);
  
    cardRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });
  
    return () => observer.disconnect();
  }, [data]);

  useEffect(() => {
    try {
      const fetchData = async () => {
        const response = await axios.post("https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product");
        const filteredData = response.data.data.filter(item =>
           item.product_status === "New Arrivals" &&
           item.admin_approval === "approval" &&
           item.paid_promo === "yes");
        setData(filteredData);
      }
      fetchData();
    } catch (error) {
      toast.error("Failed to fetch new arrivals.");
    }
  }, []);

  return (
    <section className="arrivals-section">
      <div className="arrivals-wrapper">

        <div className="arrivals-head" ref={headRef}>
          <h2 className="arrivals-title-text">New Arrivals</h2>
        </div>

        <div className="arrivals-grid-layout">
          {data.map((item, index) => (
            <div
              key={item.id}
              className="arrivals-item-card"
              ref={(el) => (cardRefs.current[index] = el)}
              style={{ '--delay': `${index * 90}ms` }}
            >
              <div className="arrivals-visual">
                <img src={`https://cyberathon.com/multivendor/${item.multi_image[0]}`} alt={item.product_name} />
                <div className="arrivals-new-badge">NEW</div>
                {/* <div className="arrivals-fav">♡</div> */}
                <div className="arrivals-add-layer">
                   <Link
          key={index}
          to={`/model/${item.product_id}`}
          className="w-100"
          >
                  <button className="arrivals-btn-add">QUICK ADD</button>
                  </Link>
                </div>
              </div>

              <div className="arrivals-content">
                <h3 className="arrivals-product-title">{item.product_name}</h3>
                <div className="arrivals-price-info">
                  <span className="arrivals-price-new">{item.current_price}</span>
                  <span className="arrivals-price-old">{item.old_price}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}